/**
 * The TextFieldType class is an enumeration of constant values used in setting the
 * <code>type</code> property of the TextField class.
 *
 * @see away.entities.TextField#type
 */
class TextFieldType
{
	/**
	 * Used to specify a <code>dynamic</code> TextField.
	 */
	public static DYNAMIC:string = "dynamic";

	/**
	 * Used to specify an <code>input</code> TextField.
	 */
	public static INPUT:string = "input";

	/**
	 * Used to specify an <code>static</code> TextField.
	 */
	public static STATIC:string = "input";
}

export default TextFieldType;